import { PeekLogoIcon, PeekLogoIconDiscover } from "@piiqtechnologies/svg-icons";
import { PeekBox, PeekContainer, PeekGrid, PeekPaper, PeekStack, styled } from "@piiqtechnologies/ui-components";
import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { PATHS } from "@constants/Paths";
const PeekLogoTop = styled(PeekLogoIcon)(({ theme }) => ({
    fontSize: theme.spacing(9),
    color: theme.palette.primary.dark,
    position: "absolute",
    top: 0,
    left: 30,
}));
const PeekLogoBox = styled(PeekLogoIconDiscover)(({ theme }) => ({
    marginTop: theme.spacing(-5),
    fontSize: theme.spacing(6),
    color: theme.palette.primary.dark,
}));
export const BoxLayout = () => {
    const location = useLocation();
    const isTermsAndConditionsAgreement = location.pathname.includes("terms-conditions-agreement");
    const backgroundImage = location.pathname === PATHS.LOGIN ? "/images/peek_discover_bg_1.svg" : "/images/peek_discover_bg_2.svg";
    if (isTermsAndConditionsAgreement) {
        return (React.createElement(PeekContainer, { maxWidth: "md", sx: { display: "flex", justifyContent: "center" } },
            React.createElement(PeekStack, { height: "100vh", direction: "row", alignItems: "center", justifyContent: "center" },
                React.createElement(PeekLogoTop, null),
                React.createElement(PeekPaper, { sx: {
                        width: 650,
                        overflow: "hidden",
                    }, elevation: 2 },
                    React.createElement(PeekStack, { direction: "column" },
                        React.createElement(PeekBox, { p: 3 },
                            React.createElement(Outlet, null)))))));
    }
    return (React.createElement(PeekContainer, { maxWidth: "md", sx: { display: "flex", justifyContent: "center" } },
        React.createElement(PeekStack, { height: "100vh", direction: "row", alignItems: "center", justifyContent: "center" },
            React.createElement(PeekLogoTop, null),
            React.createElement(PeekPaper, { sx: {
                    width: { xs: "92vw", sm: "90vw", md: 900 },
                    maxWidth: { xs: 450, sm: "none" },
                    height: { xs: "auto", md: 550 },
                    overflow: "hidden",
                }, elevation: 2 },
                React.createElement(PeekStack, { direction: "column", height: "100%" },
                    React.createElement(PeekBox, { p: 3, height: "100%" },
                        React.createElement(PeekGrid, { container: true, height: "100%" },
                            React.createElement(PeekGrid, { item: true, xs: 12, md: 6, maxHeight: "100%", sx: { display: { xs: "none", md: "block" } } },
                                React.createElement(PeekBox, { component: "img", 
                                    // @ts-ignore
                                    src: backgroundImage, width: "100%", height: "100%", borderRadius: 2, sx: { objectFit: "cover" } })),
                            React.createElement(PeekGrid, { item: true, xs: 12, md: 6, p: 3, pb: 1.5 },
                                React.createElement(PeekLogoBox, null),
                                React.createElement(Outlet, null)))))))));
};
export default BoxLayout;
